// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3YpAS","messages":"Chat_messages__1_Zs3","dateDivider":"Chat_dateDivider__onFBw"};